if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(html);
          })
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }


      renderPreview(html) {
        const drawerContent = document.querySelector('pickup-availability-drawer .product-popup-modal__content-info');
        const newContent = html.querySelector('pickup-availability-drawer .product-popup-modal__content-info');

        const previews = document.querySelectorAll('pickup-availability-preview');
        const newPreview = html.querySelector('pickup-availability-preview');

        if (drawerContent && newContent) {
          drawerContent.innerHTML = newContent.innerHTML
        }

        if (newPreview) {
          previews.forEach(preview => {
            preview.innerHTML = newPreview.innerHTML
          })
        }

      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends ModalDialog {
      constructor() {
        super();
      }
    }
  );
}